/* Netwerkloods — extra's: inzoomen op productfoto's, meescrollende koopbalk, laatst bekeken, contactformulier vooraf invullen, terug naar boven. */
(function () {
  'use strict';

  var strings = (window.theme && window.theme.strings) || {};

  /* ---------- Inzoomen op productfoto's ----------
     Muis: inzoomen zodra je over de foto beweegt; de uitsnede volgt de muis.
     Touch: tik om in te zoomen (en sleep om te verschuiven), tik nogmaals om terug te gaan. */
  function initHoverZoom() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var ZOOM = 2.5;

    gallery.querySelectorAll('.gallery__slide[data-zoom-src]').forEach(function (slide) {
      var lens = null;
      var active = false;

      function ensureLens() {
        if (lens) return lens;
        lens = document.createElement('span');
        lens.className = 'gallery__zoom-lens';
        lens.setAttribute('aria-hidden', 'true');
        lens.style.backgroundImage = 'url("' + slide.getAttribute('data-zoom-src') + '")';
        lens.style.backgroundSize = (ZOOM * 100) + '%';
        slide.appendChild(lens);
        return lens;
      }
      function move(e) {
        var r = slide.getBoundingClientRect();
        var x = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1);
        var y = Math.min(Math.max((e.clientY - r.top) / r.height, 0), 1);
        ensureLens().style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
      }
      function start(e) {
        move(e);
        active = true;
        slide.classList.add('is-zooming');
      }
      function stop() {
        active = false;
        slide.classList.remove('is-zooming');
      }

      slide.classList.add('is-zoomable');
      slide.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') start(e); });
      slide.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'mouse' && !active) start(e);
        else if (active) move(e);
      });
      slide.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') stop(); });
      slide.addEventListener('click', function (e) {
        if (e.pointerType === 'mouse' || matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        if (active) stop(); else start(e);
      });
      // Tijdens inzoomen op touch: slepen verschuift de uitsnede in plaats van de pagina te scrollen.
      slide.addEventListener('touchmove', function (e) {
        if (!active) return;
        e.preventDefault();
        move(e.touches[0]);
      }, { passive: false });
    });

    // Bij het wisselen van foto (miniaturen) de zoom van de vorige foto opheffen.
    gallery.addEventListener('click', function (e) {
      if (!e.target.closest('[data-media-target]')) return;
      gallery.querySelectorAll('.gallery__slide.is-zooming').forEach(function (s) { s.classList.remove('is-zooming'); });
    });
  }

  /* ---------- Meescrollende koopbalk ---------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    var info = document.querySelector('product-info');
    if (!bar || !info || !('IntersectionObserver' in window)) return;
    var priceEl = bar.querySelector('[data-sticky-price]');
    var vatEl = bar.querySelector('[data-sticky-price-vat]');
    var action = bar.querySelector('[data-sticky-action]');

    function buyRegion() { return info.querySelector('[data-product-region="buy"]'); }

    function sync() {
      var price = info.querySelector('[data-product-region="price"] .price__current');
      priceEl.textContent = price ? price.textContent.trim() : '';
      if (vatEl) {
        var vat = info.querySelector('[data-product-region="price"] .price__vat');
        vatEl.textContent = vat ? vat.textContent.trim() : '';
        vatEl.hidden = !vat;
      }
      var region = buyRegion();
      var inCart = inCartPanel(region);
      if (inCart) {
        var qtyInput = inCart.querySelector('[data-in-cart-qty]');
        action.textContent = (strings.inCartQuantity || '').replace('[quantity]', qtyInput ? qtyInput.value : '');
        action.disabled = false;
        action.hidden = false;
        action.classList.add('button--cart');
        return;
      }
      var primary = region && (region.querySelector('[data-inquiry-button]') || region.querySelector('[type="submit"][name="add"]'));
      action.textContent = primary ? primary.textContent.trim() : '';
      action.disabled = !primary || primary.disabled;
      action.hidden = !primary;
      // Groen alleen als het de koopknop is, niet bij 'Prijs aanvragen'.
      action.classList.toggle('button--cart', !!primary && !primary.hasAttribute('data-inquiry-button'));
    }

    function inCartPanel(region) {
      return region && region.querySelector('[data-in-cart]:not([hidden])');
    }

    document.addEventListener('cart:updated', function () {
      if (bar.classList.contains('is-visible')) sync();
    });

    action.addEventListener('click', function () {
      var region = buyRegion();
      if (!region) return;
      // Zit al in de winkelwagen: naar het aantal scrollen, niet nog een keer toevoegen.
      if (inCartPanel(region)) {
        region.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var inquiry = region.querySelector('[data-inquiry-button]');
      if (inquiry) { window.location.href = inquiry.href; return; }
      var submit = region.querySelector('[type="submit"][name="add"]');
      var form = submit && submit.form;
      if (!form || submit.disabled) {
        region.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
      else submit.click();
    });

    var target = buyRegion() || info;
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      if (past) sync();
      bar.hidden = false;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      action.tabIndex = past ? 0 : -1;
      bar.inert = !past;
      document.body.classList.toggle('has-sticky-buy', past);
    });
    observer.observe(target);
  }

  /* ---------- Laatst bekeken producten (alleen in de browser van de bezoeker) ---------- */
  var RV_KEY = 'prolec:recently-viewed';
  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) { /* opslag niet beschikbaar */ }
  }
  function initRecentlyViewed() {
    var currentEl = document.querySelector('[data-recently-viewed-current]');
    var current = null;
    if (currentEl) {
      try { current = JSON.parse(currentEl.textContent); } catch (e) { current = null; }
    }
    var list = readRecent();
    var section = document.querySelector('[data-recently-viewed]');

    if (section) {
      var limit = parseInt(section.getAttribute('data-limit'), 10) || 4;
      var items = list.filter(function (p) { return !current || p.handle !== current.handle; }).slice(0, limit);
      var ul = section.querySelector('[data-recently-viewed-list]');
      if (items.length && ul) {
        items.forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'rv-card';
          var a = document.createElement('a');
          a.href = p.url;
          a.className = 'rv-card__link';
          var media = document.createElement('span');
          media.className = 'rv-card__media';
          if (p.image) {
            var im = document.createElement('img');
            im.src = p.image;
            im.alt = '';
            im.loading = 'lazy';
            im.width = 240;
            im.height = 240;
            media.appendChild(im);
          }
          a.appendChild(media);
          if (p.vendor) {
            var v = document.createElement('span');
            v.className = 'eyebrow rv-card__vendor';
            v.textContent = p.vendor;
            a.appendChild(v);
          }
          var t = document.createElement('span');
          t.className = 'rv-card__title';
          t.textContent = p.title;
          a.appendChild(t);
          if (p.price) {
            var pr = document.createElement('span');
            pr.className = 'rv-card__price';
            pr.textContent = p.price;
            a.appendChild(pr);
            if (p.priceVat) {
              var pv = document.createElement('span');
              pv.className = 'rv-card__vat';
              pv.textContent = p.priceVat;
              a.appendChild(pv);
            }
          }
          li.appendChild(a);
          ul.appendChild(li);
        });
        section.hidden = false;
      }
      var clear = section.querySelector('[data-recently-viewed-clear]');
      if (clear) clear.addEventListener('click', function () {
        writeRecent(current ? [current] : []);
        section.hidden = true;
      });
    }

    if (current && current.handle) {
      list = list.filter(function (p) { return p.handle !== current.handle; });
      list.unshift(current);
      writeRecent(list.slice(0, 12));
    }
  }

  /* ---------- Contactformulier vooraf invullen (productvraag, prijsaanvraag, adviesgesprek) ---------- */
  function initContactPrefill() {
    var data = document.querySelector('[data-contact-prefill]');
    if (!data) return;
    var params = new URLSearchParams(window.location.search);
    var product = params.get('product');
    var type = params.get('vraag');
    if (type !== 'advies') {
      if (!product) return;
      if (type !== 'prijs' && type !== 'units') type = 'vraag';
    }
    var sku = params.get('sku');
    var link = params.get('link');
    // Alleen links naar deze winkel meenemen.
    if (link && link.indexOf(window.location.origin + '/') !== 0) link = null;

    var body = document.getElementById('ContactForm-body');
    if (body && type === 'advies') {
      // Advies: geen standaardzin in het bericht, maar een aanwijzing naast en in het veld.
      // Een placeholder wordt nooit verstuurd; het veld blijft verplicht.
      var hint = document.querySelector('[data-contact-advice-hint]');
      if (hint) {
        hint.hidden = false;
        body.setAttribute('aria-describedby', hint.id);
      }
      body.placeholder = data.getAttribute('data-placeholder-advies') || '';
      var context = params.get('context');
      if (context && !body.value.trim()) {
        body.value = data.getAttribute('data-context-label') + ' ' + context.slice(0, 500) + '\n\n';
      }
    } else if (body && !body.value.trim()) {
      var text = (data.getAttribute('data-text-' + type) || '[product]').replace('[product]', product || '');
      if (sku) text += ' (' + data.getAttribute('data-sku-label') + ': ' + sku + ')';
      if (link) text += '\n' + data.getAttribute('data-link-label') + ': ' + link;
      body.value = text + '\n\n';
    }
    // Productnaam en -link ook als losse velden meesturen, ook als de klant het bericht aanpast.
    var form = document.getElementById('ContactForm');
    if (form && type !== 'advies' && product) {
      [['data-field-product', product], ['data-field-link', link]].forEach(function (pair) {
        var name = data.getAttribute(pair[0]);
        if (!name || !pair[1] || form.querySelector('input[name="' + name + '"]')) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = pair[1];
        form.appendChild(input);
      });
      var shown = document.querySelector('[data-contact-product]');
      if (shown) {
        var label = shown.querySelector('[data-contact-product-name]');
        if (label) label.textContent = product;
        var a = shown.querySelector('a');
        if (a && link) { a.href = link; a.hidden = false; }
        shown.hidden = false;
      }
    }
    var subject = document.getElementById('ContactForm-subject');
    var wanted = data.getAttribute('data-subject-' + type);
    if (subject && wanted) {
      var match = Array.prototype.filter.call(subject.options, function (o) {
        return o.value.toLowerCase() === wanted.toLowerCase();
      })[0];
      // Onderwerp ontbreekt in de lijst (bijv. 'Adviesgesprek'): dan toevoegen, zodat het mee wordt verstuurd.
      if (!match) {
        match = new Option(wanted, wanted);
        subject.insertBefore(match, subject.firstChild);
      }
      subject.value = match.value;
    }
    var name = document.getElementById('ContactForm-name');
    if (name && !name.value) name.focus({ preventScroll: true });
    else if (type === 'advies' && body) body.focus({ preventScroll: true });
  }

  /* ---------- Contactformulier netjes in beeld bij #ContactForm ----------
     De browser springt naar het formulier zelf (onder de kop van de kaart) en houdt geen
     rekening met de precieze hoogte van de vaste header. Daarom zetten we de hele
     formulierkaart direct onder de header, ook na het laden van afbeeldingen en lettertypen. */
  function initContactAnchor() {
    if (window.location.hash !== '#ContactForm') return;
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var card = form.closest('.page-card') || form;

    function headerOffset() {
      var header = document.querySelector('.site-header');
      if (!header) return 0;
      var sticky = header.closest('.section-site-header, .shopify-section') || header;
      var pos = window.getComputedStyle(sticky).position;
      return pos === 'sticky' || pos === 'fixed' ? sticky.getBoundingClientRect().height : 0;
    }
    var userScrolled = false;
    function align() {
      if (userScrolled) return;
      var top = card.getBoundingClientRect().top + window.scrollY - headerOffset() - 24;
      window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
    }

    align();
    // Header kan na scrollen compacter worden: één keer nameten.
    requestAnimationFrame(align);
    window.addEventListener('load', align, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(align);
    // Stoppen zodra de bezoeker zelf scrolt.
    ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, function () { userScrolled = true; }, { once: true, passive: true });
    });
  }

  /* ---------- Terug naar boven ---------- */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;
    var visible = false;
    function update() {
      var show = window.scrollY > window.innerHeight * 1.5;
      if (show === visible) return;
      visible = show;
      btn.hidden = false;
      btn.classList.toggle('is-visible', show);
      btn.tabIndex = show ? 0 : -1;
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      var main = document.getElementById('MainContent');
      if (main) main.focus({ preventScroll: true });
    });
  }

  /* Partnerkorting: zet de kortingscode van het partnerniveau van een ingelogde partner op de winkelwagen.
     De code staat alleen in de pagina als de klant een partnertag heeft (layout/theme.liquid).
     Shopify controleert bij het afrekenen zelf of de code voor deze klant geldt (klantsegment). */
  function initPartnerCode() {
    var el = document.querySelector('[data-partner-code]');
    if (!el || !window.fetch) return;
    var code = el.getAttribute('data-partner-code');
    if (!code) return;
    var busy = false;

    function ensure(e) {
      if (busy) return;
      busy = true;
      // Na een wijziging zit de hele winkelwagen al in het event; dan is geen extra verzoek nodig.
      var known = e && e.detail && e.detail.token && e.detail.discount_codes ? e.detail : null;
      (known ? Promise.resolve(known) : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }))
        .then(function (cart) {
          if (!cart || !cart.item_count) return;
          var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
          var has = codes.some(function (c) { return String(c).toLowerCase() === code.toLowerCase(); });
          if (has) return;
          var key = 'prolec-partner-code-' + cart.token + '-' + code;
          try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (e) {}
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.concat(code).join(',') })
          }).then(function (r) {
            if (r.ok && /\/cart\/?$/.test(window.location.pathname)) window.location.reload();
          });
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }

    ensure();
    document.addEventListener('cart:updated', ensure);
  }

  function init() {
    initHoverZoom();
    initStickyBuy();
    initRecentlyViewed();
    initContactPrefill();
    initContactAnchor();
    initBackToTop();
    initPartnerCode();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
